import events from './events';
import companies from './companies';
import guests from './guests';

export default {
  namespaced: true,
  modules: {
    events,
    companies,
    guests,
  },
};
